<template>
	<v-layout>
    <v-flex class="left-label" xs12>
			{{ items }}
		<v-data-table
			:headers="headers"
			:items="items"
			:single-expand="singleExpand"
			:expanded.sync="expanded"
			item-key="header"
			show-expand
			class="elevation-1"
    >
		<!--<template v-slot:expanded-item="{ items }">
        <td :colspan="items.length">
        <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>(a) Federal</th>
										<th>(b) FFRDCs</th>
										<th>(c) Businesses</th>
										<th>(d) Higher education</th>
										<th>(e) Other nonprofits</th>
										<th>(f) State and local government</th>
										<th>(g) Total R&D conduct in state</th>
									</tr>
							</thead>
                <tbody>
                  <tr v-for="item in items" :key="item.answers">
                    <td><value-cell
         								:has-outline="hasOutline"
												:is-read-only="readOnly"
												:index="parseInt(index)"
												:name="item.qId"
												prefix="$"
												:id="qId"
												:value="item.qId"
												v-on:update="onUpdateRowAnswers"
											></value-cell></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
      </template>-->
    </v-data-table>
		</v-flex>
	</v-layout>
</template>
<script>
export default {
	name: 'StateComponent',
	props: {
    //qId: String,
		//items: []
	},
	data: () => ({
			singleExpand: false,
			expanded: [],
      headers: [
				{ text: 'S.No', value: 'header' },
        { text: 'States', value: 'label' },
        { text: '', value: 'data-table-expand' }
      ],
			items: []
    })
	}
</script>
<style scoped>
	.row-header {
		font-weight: bold;
		color: #13314f;
	}
	.tb-width {
		min-width: 150px;
	}
	.left-label {
		margin-top: 17px;
		min-width: 450px;
	}
	/* hover effect on answer rows.  TODO: not show hover effect on rows that are all totals */
	div.layout.answers-row:hover {
		border-radius: 5px;
		background-color: #300fec;
	}
</style>
